import { IApplicationState } from '../../types/redux';

export const getTimezone = (state: IApplicationState) => {
  return state.newbuilding.geo.timezone;
};
